import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";

export function Shell() {
  const [manual, setManual] = useState(() => localStorage.getItem("nb_sidebar_collapsed") === "1");
  const [narrow, setNarrow] = useState(() => (typeof window !== "undefined" ? window.innerWidth < 1200 : false));

  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < 1200);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("nb_sidebar_collapsed", manual ? "1" : "0");
  }, [manual]);

  const collapsed = manual || narrow;

  return (
    <div className="min-h-screen bg-nb-bg">
      <Sidebar collapsed={collapsed} onToggle={() => setManual((c) => !c)} />
      <div className="transition-[margin] duration-200" style={{ marginLeft: collapsed ? 72 : 240 }}>
        <Topbar />
        <main className="max-w-content mx-auto px-6 lg:px-8 py-8 nb-fade">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
